import { type FC } from 'react';
import RegisterLayout from '@/registration/component/Register/Layout';
import InviteeForm from './InviteeForm';

const InviteeTermsPrivacy: FC = () => {
  return (
    <RegisterLayout header={null}>
      <InviteeForm />
    </RegisterLayout>
  );
};

export default InviteeTermsPrivacy;
